/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portfolio_Project_8_ResultInputs */

const et_portfolio_project_8_result = /** @type {(inputs: Portfolio_Project_8_ResultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kaasatus paranes 30% ja kohalik otsingunähtavus kasvas 3 kuu jooksul.`)
};

const en_portfolio_project_8_result = /** @type {(inputs: Portfolio_Project_8_ResultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Improved engagement by 30% and increased local search visibility within 3 months.`)
};

/**
* | output |
* | --- |
* | "Improved engagement by 30% and increased local search visibility within 3 months." |
*
* @param {Portfolio_Project_8_ResultInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const portfolio_project_8_result = /** @type {((inputs?: Portfolio_Project_8_ResultInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portfolio_Project_8_ResultInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_portfolio_project_8_result(inputs)
	return en_portfolio_project_8_result(inputs)
});